const API_URL = `${process.env.REACT_APP_API}/api/products`;

// Request cache with timestamp-based invalidation
const requestCache = new Map();
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

// Generic fetch with caching
async function fetchWithCache(url, cacheKey) {
  const now = Date.now();
  const cached = requestCache.get(cacheKey);
  
  // Return cached data if valid
  if (cached && (now - cached.timestamp < CACHE_DURATION)) {
    return cached.data;
  }
  
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Failed to fetch ${cacheKey}`);
  const data = await res.json();
  
  // Update cache
  requestCache.set(cacheKey, { data, timestamp: now });
  return data;
}

export const getTopProducts = async () => {
  return fetchWithCache(`${API_URL}/top`, 'topProducts');
};

export const getNewArrivals = async () => {
  return fetchWithCache(`${API_URL}/new-arrivals`, 'newArrivals');
};

export const getFeaturedProducts = async () => {
  // Don't cache featured products - always fetch fresh to reflect admin changes immediately
  const res = await fetch(`${API_URL}/featured`);
  if (!res.ok) throw new Error('Failed to fetch featured products');
  return res.json();
};

export const getTopSelling = async () => {
  return fetchWithCache(`${API_URL}/top-selling`, 'topSelling');
};
